import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { TemplateWrapper } from "@/modules/template/components/sidebarImport/templateWrapper"
import { TemplateType } from "@/modules/template/types/templateType"
import { Text } from "@/components/ui/baseUi/text"
import { TemplateButtons } from "@/modules/template/components/sidebarImport/templateButtons"
import { useApplySessionTemplate } from "@/modules/template/hooks/useTemplate"
import { useSidebar } from "@/modules/sidebar/hooks/useSidebar"
import dayjs from "dayjs"
import { appToast as toast, errorToastClassName, successToastClassName } from "@/components/ui/baseUi/sonner"

type TemplateImportSessionViewProps = {
  programId: string
  options: {
    virtualProgramByDateIndex: number | null
    date: Date | null
    index: number | null
  }
  className?: string
} & React.ComponentProps<"div">

export function TemplateImportSessionView({ programId, options, className, ...props }: TemplateImportSessionViewProps) {
  const { mutateAsync: applySessionTemplate } = useApplySessionTemplate()
  const { hideSidebar } = useSidebar()

  const handleValidateSessionTemplate = async (templateId: string) => {
    await applySessionTemplate({
      templateId,
      applySessionTemplateInput: {
        programId,
        date: options.date ? dayjs(options.date).format("YYYY-MM-DD") : null,
        index: options.index,
        virtualProgramByDateIndex: null,
      },
    })
      .then(() => {
        toast.success(word("template.session.toast.import.success"), {
          classNames: successToastClassName(),
        })
        hideSidebar()
      })
      .catch(() => {
        toast.error(word("template.session.toast.import.error"), {
          classNames: errorToastClassName(),
        })
      })
  }

  return (
    <div className={cn("flex flex-1 flex-col gap-4 pt-18", className)} {...props}>
      <div className="flex flex-1 grow flex-col gap-8">
        <Text fontStyle="TL" className="px-6">
          {word("templateType.import.title.session")}
        </Text>
        <TemplateWrapper templateType={TemplateType.SESSION} />
      </div>
      <TemplateButtons
        className="sticky bottom-0 flex flex-row gap-2 bg-surface-background-default px-6 pt-4 pb-2"
        onValidate={(templateId: string) => {
          void handleValidateSessionTemplate(templateId)
        }}
      />
    </div>
  )
}
